import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// import { NavController, ModalController } from '@ionic/angular';
import { ActivatedRoute } from '@angular/router';
//import { ApiProviderService } from '../../core/auth/_services/api-provider.service';
import { User} from '../../../../core/auth/_models/user';
// import {ModalPictureComponent} from '../../@componente/modal-picture/modal-picture.component';
// import { from } from 'rxjs';
// import { FirmaComponent } from '../../@componente/firma/firma.component';
//import {SafetekInstallation} from '../../core/auth/_models/installationData';
// import {PictureType} from '../../core/auth/_models/PictureType'
// import {LocalStorageService} from '../../core/auth/_services/local.storage.service'
import { map } from 'rxjs/operators';
import { AlarmService } from '../../../../core/alarm/services/alarm.service';
import { timestamp } from '../../../../core/_base/util/date.util';
import * as _ from 'lodash'
import { SensorDataService } from '../../../../core/device/services/sensor-data.service';

@Component({
  selector: 'app-variable-history',
  templateUrl: './variable-history.page.html',
  styleUrls: ['./variable-history.page.scss'],
})
export class VariableHistoryPage implements OnInit {

  @Input() location: any;
  @Input() device: any;
  @Output() closeRequested = new EventEmitter<void>();
  c_user : User;
  node: any;

  thresholds = {
    temperature: 25.0,
    humidity: 75.0,
    co_ppm: 1,
    co_vgas: 20
  };

  segmentList = [
    // {value: "temperature", text: "Temperatura"},
    // {value: "co_ppm", text: "CO PPM"},
    // {value: "humidity", text: "Humedad"},
  ]

  titles = {
    temperature: 'Alarmas últimas 24 horas',
    humidity: 'Humedad últimas 24 horas',
    co_ppm: 'CO PPM últimas 24 horas',
    co_vgas: 'CO VGAS últimas 24 horas'
  }
  chart: any = {
    data: [],
    secureThreshold: 0,
    title: 'Alarmas últimas 24 horas',
    label: 'alarmas'
  };
  selectedSegment: string = "temperature";
  alarmList: any[] = [];
  loading = true;
  loadError = false;
  lastSensorData: any;
  chartPeriodStart: Date;
  chartPeriodEnd: Date;
  alarmChartData: any[] = [];
  alarmChartColors: any[] = [{
    borderColor: '#ef535d',
    backgroundColor: 'rgba(239, 83, 93, .08)',
    pointBackgroundColor: '#ef535d',
    pointBorderColor: '#fff'
  }];
  alarmChartOptions: any = {};
  alarmChartType = 'line';
  constructor(
    // public navCtrl: NavController,
     private route: ActivatedRoute,
    //  public modalController: ModalController,
    //  private locaStorage : LocalStorageService,
     private alarmService: AlarmService,
     private sensorDataService: SensorDataService
  ) {
    this.c_user = {
      uid : Number(localStorage.getItem('uid')),
      name : localStorage.getItem('name'),
      group_id : localStorage.getItem('group_id'),
      maintenance_team_id : localStorage.getItem('maintenance_team_id'),
      partner_id : localStorage.getItem('partner_id'),
    };
    //this.dataService.set_pictureType(PictureType.WORKGUIDE);
  }
  
  ngOnInit() {
    //HERE I WILL CALL THE DB TO RETRIEVE DATA FOR THE INSTALLATION, CONTRACT AND SYSTEM, SUB-SYSTEMS
    var resp = this.route.params.subscribe(params => {
      this.node = {
        central_id : params['central_id'],
        central_status_name : params['central_status_name'],
        installation_name : params['installation_name'],
        last_data_time : params['last_data_time'],
      }
      console.log("node: ");
      console.dir(this.node);
      console.log("params: ");
      console.dir(params);

      this.fetchData();
    });
  }

  fetchData(){
    this.loading = true;
    this.loadError = false;
    const st = new Date();
    const et = new Date();
    st.setHours(0, 0, 0, 0);
    et.setSeconds(0, 0);
    this.chartPeriodStart = new Date(st);
    this.chartPeriodEnd = new Date(et);
    let filterOp = {
      // location_id: this.location.id,
      st: timestamp(st),
      et: timestamp(et),
      alarm_status_id: 1,
      simple: true
    }
    if(this.device){
      filterOp['device_id'] = this.device.id;
    }else{
      filterOp['location_id'] = this.location.id;
    }
    this.alarmService.getPage({
        sortField: "id",
        sortOrder: "desc",
        pageSize: 0,
        pageNumber: 0,
        filter: filterOp
      } as any).pipe(
        map((response: any) => response && Array.isArray(response.items) ? response.items : [])
    ).subscribe(alarmList=>{
      this.loading = false;
      this.alarmList = alarmList.sort(function compare(a, b) {
        var dateA = new Date(a.create_date);
        var dateB = new Date(b.create_date);
        return dateA.getTime() - dateB.getTime();
      });
      const data = this.generateAlarmData(alarmList);
      this.chart.data = data;
      this.updateAlarmChart(data);
      // console.log("going to open alarm modal with alarm list");console.dir(alarmList);
      
    }, () => {
      this.loading = false;
      this.loadError = true;
    })
    // this.api.get_last_data_id(this.node.central_id)
    //     .then((data:any) => {
    //         console.log("data retrieved: ");
    //         console.dir(data);
    //         if (data && data.length && data.length>0){
    //           // this.graphs_data = data; 
    //           let values = [];
    //           data.forEach(row=>{
    //             const date = new Date(new Date(row.write_date).toLocaleString('es-CL'));
    //             this.chart.data = [];                
    //             values.push(
    //               {label: date.toLocaleTimeString(), value: parseFloat(row[this.selectedSegment])}
    //             );
                
    //           });
    //           this.chart.data = values;
    //           this.chart.title = this.titles[this.selectedSegment];
    //           this.chart.secureThreshold = this.thresholds[this.selectedSegment];
    //           this.chart.label = this.selectedSegment;
    //           console.log("chart ");console.dir(this.chart);
    //           const lastDate = new Date(data[data.length-1].write_date);
    //           this.node.last_data_time = formatDate(lastDate);
    //           this.cdr.detectChanges();
    //         }    
    //     });

    const targetDevice = this.device || _.get(this.location, 'Devices[0]');
    if (targetDevice && targetDevice.id) this.sensorDataService.instant({
      device_id: targetDevice.id
    }).subscribe((response:any)=>{
        console.log("response for instant")
        console.dir(response);
        const data = response.itemList;
        this.lastSensorData = null;
        if(data && data.length>0){
          this.lastSensorData = data[0];
          this.lastSensorData.create_date = this.normalizeSensorDate(this.lastSensorData.create_date);
        }
    }, () => {
      this.lastSensorData = null;
    })
  }

  get activeDevice(): any {
    return this.device || _.get(this.location, 'Devices[0]') || {};
  }

  get deviceDescription(): string {
    return this.activeDevice.description || this.activeDevice.name || 'Dispositivo sin descripción';
  }

  get deviceTypeName(): string {
    return _.get(this.activeDevice, 'DeviceType.name') || 'Zona infrarroja';
  }

  get altitudeLabel(): string {
    const rawAltitude = this.location && this.location.high_m;
    const altitude = Number(rawAltitude);
    return rawAltitude !== null && rawAltitude !== undefined && rawAltitude !== '' && Number.isFinite(altitude)
      ? `${altitude} m`
      : 'Sin información';
  }

  private normalizeSensorDate(value: any): Date | null {
    if (value === null || value === undefined || value === '') return null;
    const numericValue = typeof value === 'number' || /^\d+$/.test(String(value)) ? Number(value) : null;
    const date = numericValue !== null
      ? new Date(numericValue > 0 && numericValue < 1000000000000 ? numericValue * 1000 : numericValue)
      : new Date(value);
    return !isNaN(date.getTime()) && date.getFullYear() >= 2000 ? date : null;
  }

  /*generateAlarmData(alarmList:any[]){
    const data = [];

    //Ordena alarmas
    alarmList = _.sortBy(alarmList, [(alarm)=>new Date(alarm.create_date).getTime()])
    console.log("ordered alarm list: ");console.dir(alarmList);

    //Rellena data
    let prevHour = 0;
    for(let alarm of alarmList){
      const alarmDate = new Date(alarm.create_date);
      const alarmHours = alarmDate.getHours(); //!* 60 + alarmDate.getMinutes();

      if(prevHour > alarmHours){
        continue;
      }

      alarmDate.setMinutes(0);
      alarmDate.setSeconds(0);
      for(let hour = prevHour; hour<alarmHours; hour++){
        const date = new Date(alarmDate);
        date.setHours(hour);
        data.push({
          value: 0,
          label: timestamp(date).split(' ')[1],
        })
      }
      
      data.push({
        value: 1,
        label: timestamp(alarmDate).split(' ')[1]
      });
      prevHour = alarmHours + 1;
    }

    for(let hour = prevHour; hour<=new Date().getHours(); hour++){
      const date = new Date();
      date.setHours(hour);
      data.push({
        value: 0,
        label: timestamp(date).split(' ')[1],
      })
    }

    return data;
  }*/

  generateAlarmData(alarmList:any[]){
    const data = [];
    const st = this.chartPeriodStart ? new Date(this.chartPeriodStart) : new Date();
    const et = this.chartPeriodEnd ? new Date(this.chartPeriodEnd) : new Date();
    st.setSeconds(0, 0);
    et.setSeconds(0, 0);

    // Mantiene la resolución por minuto para que el eje X represente fielmente
    // el período consultado y no agrupe alarmas distintas en una misma hora.
    const alarmMinutes = new Set(
      (alarmList || [])
        .map(alarm => new Date(alarm.create_date))
        .filter(alarmDate => !isNaN(alarmDate.getTime()))
        .map(alarmDate => {
          alarmDate.setSeconds(0, 0);
          return alarmDate.getTime();
        })
    );

    const currentMinute = new Date(st);
    while (currentMinute.getTime() <= et.getTime()) {
      data.push({
        value: alarmMinutes.has(currentMinute.getTime()) ? 1 : 0,
        label: timestamp(currentMinute).split(' ')[1].slice(0, 5)
      });
      currentMinute.setMinutes(currentMinute.getMinutes() + 1);
    }

    return data;
  }

  get chartPeriodLabel(): string {
    if (!this.chartPeriodStart || !this.chartPeriodEnd) return 'Últimas 24 horas';
    return `Hoy · ${this.formatTime(this.chartPeriodStart)}–${this.formatTime(this.chartPeriodEnd)}`;
  }

  private formatTime(date: Date): string {
    return `${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
  }

  private updateAlarmChart(data: any[]): void {
    const start = this.chartPeriodStart ? new Date(this.chartPeriodStart) : new Date();
    start.setSeconds(0, 0);
    const points = (data || []).map((row: any, index: number) => ({
      x: new Date(start.getTime() + index * 60000),
      y: Number(row.value) > 0 ? 1 : 0
    }));
    const endOfDay = new Date(start);
    endOfDay.setHours(23, 59, 59, 999);

    this.alarmChartData = [{
      data: points,
      label: 'Alarmas',
      borderWidth: 2,
      fill: true,
      spanGaps: true
    }];
    this.alarmChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      animation: { duration: 350, easing: 'easeOutQuart' },
      elements: {
        line: { tension: 0 },
        point: { radius: 0, hoverRadius: 5, hitRadius: 12 }
      },
      tooltips: {
        enabled: true,
        mode: 'nearest',
        intersect: false,
        callbacks: {
          title: (items: any[]) => {
            const item = items && items.length ? items[0] : null;
            return item ? this.formatChartTooltipDate(item.xLabel) : '';
          },
          label: (item: any) => Number(item && item.yLabel) > 0
            ? 'Alarma detectada'
            : 'Sin alarma'
        }
      },
      hover: { mode: 'nearest', intersect: false },
      scales: {
        xAxes: [{
          type: 'time',
          distribution: 'linear',
          gridLines: { color: 'rgba(148, 163, 184, .10)' },
          time: {
            min: start,
            max: endOfDay,
            unit: 'hour',
            stepSize: 6,
            displayFormats: { hour: 'HH:mm' },
            tooltipFormat: 'DD/MM/YYYY HH:mm'
          },
          ticks: { fontColor: '#aebbc9', maxRotation: 0, minRotation: 0 }
        }],
        yAxes: [{
          scaleLabel: { display: false },
          ticks: {
            min: 0,
            max: 1,
            stepSize: 1,
            fontColor: '#aebbc9',
            callback: (value: number) => String(value)
          },
          gridLines: { color: 'rgba(148, 163, 184, .16)' }
        }]
      },
      legend: { display: false }
    };
  }

  private formatChartTooltipDate(value: any): string {
    const date = value instanceof Date ? value : new Date(value);
    if (isNaN(date.getTime())) return '';
    return `${String(date.getDate()).padStart(2, '0')}/${String(date.getMonth() + 1).padStart(2, '0')}/${date.getFullYear()} ${this.formatTime(date)}`;
  }

  goBack(){
    this.closeRequested.emit();
  }
  segmentChanged(event){
    this.selectedSegment = event.detail.value;
    console.dir(event.detail.value);
    this.fetchData();
  }

  selectVariable(event){
    this.selectedSegment = event.detail.value;
    console.dir(event.detail.value);
    this.fetchData();
  }
}

function formatDate(date: Date){
  const months = [
    "enero",
    "febrero", 
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ];
  const days = [
    "Domingo",
    "Lunes",
    "Martes",
    "Miércoles",
    "Jueves",
    "Viernes",
    "Sábado"
  ]
  let monthStr = months[date.getMonth()];

  let day = date.getDate();
  // let dayStr = numberTo2DigitsString(day);
  let weekDay = days[date.getDay()];

  let year = date.getFullYear();

  let hour = date.getHours();
  let hourStr = numberTo2DigitsString(hour);
  let minute = date.getMinutes();
  let minuteStr = numberTo2DigitsString(minute);
  

  return `${day} de ${monthStr} a las ${hourStr}:${minuteStr}`;
}

function numberTo2DigitsString(number:Number){
  if(this.number<10) return `0${number}`;
  return `${number}`;
}
